module.exports = __webpack_public_path__ + "static/media/md-person-add.12ba58a7.svg";